(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Accordion interactions for standalone accordion section
    const accordionHeaders = document.querySelectorAll('.accordion__header');
    
    accordionHeaders.forEach((header) => {
      const item = header.closest('.accordion__item');
      const content = item ? item.querySelector('.accordion__content') : null;
      if (!item || !content) return;

      // Set initial state without animation
      const initiallyOpen = item.classList.contains('is-open');
      header.setAttribute('aria-expanded', initiallyOpen ? 'true' : 'false');
      content.style.maxHeight = initiallyOpen ? 'none' : '0px';

      header.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        if (isOpen) {
          // CLOSE: if max-height is none, set it to current height first to enable transition
          const currentHeight = content.scrollHeight;
          content.style.maxHeight = currentHeight + 'px';
          // force reflow to ensure the browser picks up the start height
          void content.offsetHeight;
          content.style.maxHeight = '0px';
          item.classList.remove('is-open');
          header.setAttribute('aria-expanded', 'false');
        } else {
          // OPEN: set explicit height so it animates from 0 -> height
          item.classList.add('is-open');
          header.setAttribute('aria-expanded', 'true');
          const targetHeight = content.scrollHeight;
          content.style.maxHeight = targetHeight + 'px';
          
          const onEnd = (e) => {
            if (e.propertyName !== 'max-height') return;
            // allow dynamic height after animation completes
            content.style.maxHeight = 'none';
            content.removeEventListener('transitionend', onEnd);
          };
          content.addEventListener('transitionend', onEnd);
        }
      });

      // Keep open panels sized correctly on resize/font load
      const recalc = () => {
        if (item.classList.contains('is-open')) {
          content.style.maxHeight = 'none';
        }
      };
      
      window.addEventListener('resize', recalc);
      document.fonts.ready.then(recalc);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Handle cart trigger clicks
    const cartTriggers = document.querySelectorAll('.cart-trigger');
    cartTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        if (typeof openCartSlideout === 'function') {
          openCartSlideout();
        }
      });
    });

    // Mobile menu overlay functionality
    const mobileMenuTrigger = document.querySelector('.mobile-menu-trigger');
    const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    const mobileMenuClose = document.getElementById('mobile-menu-close');

    if (mobileMenuTrigger && mobileMenuOverlay && mobileMenuClose) {
      // Open mobile menu
      mobileMenuTrigger.addEventListener('click', function() {
        mobileMenuOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      });

      // Close mobile menu
      function closeMobileMenu() {
        mobileMenuOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }

      mobileMenuClose.addEventListener('click', closeMobileMenu);

      // Close when clicking overlay background
      mobileMenuOverlay.addEventListener('click', function(e) {
        if (e.target === mobileMenuOverlay) {
          closeMobileMenu();
        }
      });

      // Close when clicking a navigation link
      const mobileMenuLinks = mobileMenuOverlay.querySelectorAll('.mobile-menu-overlay__link');
      mobileMenuLinks.forEach(link => {
        link.addEventListener('click', closeMobileMenu);
      });

      // Close when clicking cart trigger in the overlay
      const overlayCartTriggers = mobileMenuOverlay.querySelectorAll('.cart-trigger');
      overlayCartTriggers.forEach(trigger => {
        trigger.addEventListener('click', closeMobileMenu);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-block"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const carouselContainer = document.querySelector('[data-carousel-container]');
  const container = carouselContainer ? carouselContainer.querySelector('.image-block-carousel__container') : null;
  const nav = document.querySelector('[data-carousel-nav]');
  const dots = document.querySelectorAll('[data-dot-index]');
  const slides = document.querySelectorAll('[data-slide-index]');

  if (!container || !nav || dots.length === 0) return;

  let currentIndex = 0;

  // Go to specific slide
  function goToSlide(index) {
    if (index < 0 || index >= slides.length) return;
    
    currentIndex = index;

    // Move container vertically
    const offset = -index * 100;
    container.style.transform = `translateY(${offset}vh)`;

    // Update dots
    dots.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }

  // Click handlers for dots
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.getAttribute('data-dot-index'));
      goToSlide(index);
    });
  });

  // Initialize first slide
  goToSlide(0);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intro-overlay"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const introOverlay = document.getElementById('intro-overlay');
    if (!introOverlay) return;

    // Initialize real-time clock
    const timeElement = document.getElementById('intro-time');
    
    function updateTime() {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      timeElement.textContent = `${hours}:${minutes}`;
    }
    
    // Update time immediately and then every second
    updateTime();
    const timeInterval = setInterval(updateTime, 1000);
    
    // Clear interval when overlay is hidden
    function clearTimeInterval() {
      if (timeInterval) {
        clearInterval(timeInterval);
      }
    }

    // In theme editor, always show intro so it can be edited
    const isDesignMode = introOverlay.getAttribute('data-design-mode') === 'true';

    if (!isDesignMode) {
      // Check if user has seen intro before
      const hasSeenIntro = localStorage.getItem('robinhood-intro-seen');

      if (hasSeenIntro) {
        // Already hidden by inline script, just clean up and exit
        clearTimeInterval();
        if (introOverlay.parentNode) {
          introOverlay.parentNode.removeChild(introOverlay);
        }
        return;
      }
    }

    // Show intro (first-time visitors or theme editor)
    let hasInteracted = false;
    let scrollListenersEnabled = false;

    // Initialize intro as active
    introOverlay.classList.add('active');
    document.body.classList.add('intro-overlay-active');

    function hideIntro() {
      if (isDesignMode) return; // Keep overlay visible in theme editor
      if (hasInteracted) return;
      hasInteracted = true;

      // Clear the time interval
      clearTimeInterval();

      // Remove active states immediately to show floating links
      introOverlay.classList.remove('active');
      document.body.classList.remove('intro-overlay-active');

      // Always use slide-up animation
      introOverlay.classList.add('slide-up');
      
      localStorage.setItem('robinhood-intro-seen', 'true');

      // Remove from DOM after transition
      setTimeout(() => {
        if (introOverlay.parentNode) {
          introOverlay.parentNode.removeChild(introOverlay);
        }
      }, 800);
    }

    // Handle scroll attempts
    function handleScrollAttempt() {
      if (!scrollListenersEnabled) return; // Don't dismiss if listeners aren't ready
      hideIntro();
    }

    // Enable scroll listeners after a delay to prevent auto-dismissal
    setTimeout(() => {
      scrollListenersEnabled = true;
      
      // Listen for wheel events (desktop scroll)
      introOverlay.addEventListener('wheel', function (e) {
        if (e.deltaY > 0) {
          // Scrolling down
          handleScrollAttempt();
        }
      });

      // Listen for actual scroll events as backup (but be more careful)
      let initialScrollY = window.scrollY;
      window.addEventListener('scroll', function () {
        if (scrollListenersEnabled && window.scrollY > initialScrollY + 20) {
          hideIntro();
        }
      });
    }, 1000); // Wait 1 second before enabling scroll listeners

    // Add click listener to entire indicator area (dot + text)
    const indicator = introOverlay.querySelector('.intro-overlay__indicator');
    if (indicator) {
      indicator.addEventListener('click', function(e) {
        e.preventDefault();
        hideIntro();
      });
    }

    // Hide on touch move (swipe up) - but also respect the delay
    let startY = 0;
    introOverlay.addEventListener('touchstart', function (e) {
      startY = e.touches[0].clientY;
    });

    introOverlay.addEventListener('touchmove', function (e) {
      if (!scrollListenersEnabled) return; // Don't dismiss if listeners aren't ready
      
      const currentY = e.touches[0].clientY;
      const deltaY = startY - currentY;

      // If swiping up
      if (deltaY > 30) {
        hideIntro();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-logo-header"] && !Shopify.designMode) return;
  try {
    
  function syncGlobalHeaderVisibility() {
    var hasPageLogoHeader = Boolean(document.querySelector('[data-hide-global-header]'));
    document.body.classList.toggle('hide-global-header', hasPageLogoHeader);
  }

  syncGlobalHeaderVisibility();

  document.addEventListener('shopify:section:load', syncGlobalHeaderVisibility);
  document.addEventListener('shopify:section:unload', syncGlobalHeaderVisibility);
  document.addEventListener('shopify:section:reorder', syncGlobalHeaderVisibility);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  function applyPageLogoLink(scope) {
    var root = scope || document;
    var marker = root.querySelector('[data-page-logo-link]');
    if (!marker) return;

    var disable = marker.getAttribute('data-disable-logo-link') === 'true';
    document.querySelectorAll('[data-store-logo]').forEach(function (node) {
      if (disable) {
        node.removeAttribute('href');
      } else {
        var href = node.getAttribute('data-logo-href');
        if (href) node.setAttribute('href', href);
      }
    });
  }

  applyPageLogoLink(document);

  document.addEventListener('shopify:section:load', function (event) {
    applyPageLogoLink(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Price formatting function with comma separators
  function formatPrice(priceInCents) {
    const dollars = (priceInCents / 100).toFixed(2);
    // Add commas for thousands
    const formattedDollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + formattedDollars;
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Custom dropdowns functionality (both quantity and variant)
    const dropdownTriggers = document.querySelectorAll('.dropdown-trigger');
    const quantityInput = document.getElementById('quantity');
    const variantInput = document.getElementById('variant-selector');
    const mobileQuantityInput = document.getElementById('mobile-quantity');
    const mobileVariantInput = document.getElementById('mobile-variant-selector');
    const priceElements = document.querySelectorAll('.pdp-price--sale, .pdp-price--regular');
    const comparePriceElement = document.querySelector('.pdp-price--compare');
    const mobilePriceElements = document.querySelectorAll('.pdp-mobile-price__current');
    const mobileComparePriceElement = document.querySelector('.pdp-mobile-price__compare');
    const addToCartBtns = document.querySelectorAll('.pdp-add-to-cart');

    // Store all product variants data for lookup
    const productVariants = window.pdpProductVariants || [];

    function stoqIsReady() {
      return !!(window._RestockRocket && window._RestockRocket.openModal);
    }

    // Inline display:none is locked by CSS. is-visible is what actually shows the button.
    function setNotifyVisible(btn, visible) {
      if (visible) {
        btn.classList.add('is-visible');
        btn.style.setProperty('display', 'inline-block', 'important');
      } else {
        btn.classList.remove('is-visible');
        btn.style.setProperty('display', 'none', 'important');
      }
    }
    
    // Track selected options (e.g., {1: "Red", 2: "Small"})
    const selectedOptions = {};
    
    // Initial button state will be set after user selects options
    let initialButtonStateSet = false;
    
    // Auto-select any single-value options (e.g., if there's only one color)
    document.querySelectorAll('.pdp-single-option').forEach(input => {
      const position = input.getAttribute('data-option-position');
      const value = input.getAttribute('data-option-value');
      if (position && value) {
        selectedOptions[position] = value;
      }
    });

    // Helper function to find variant matching selected options
    function findVariantByOptions(options) {
      return productVariants.find(variant => {
        // Check if all selected options match this variant
        return Object.keys(options).every(position => {
          const optionIndex = parseInt(position) - 1;
          return variant.options[optionIndex] === options[position];
        });
      });
    }

    // True when a variant exists for this option. requireAvailable limits that to in-stock variants.
    function optionHasVariant(optionPosition, optionValue, requireAvailable) {
      const testOptions = {...selectedOptions};
      testOptions[optionPosition] = optionValue;

      return productVariants.some(variant => {
        const matchesSelected = Object.keys(testOptions).every(position => {
          const optionIndex = parseInt(position) - 1;
          return variant.options[optionIndex] === testOptions[position];
        });
        return matchesSelected && (!requireAvailable || variant.available);
      });
    }

    // Sold-out sizes stay selectable. Only combinations that do not exist are blocked.
    function updateOptionAvailability() {
      document.querySelectorAll('.size-option[data-option-position]').forEach(option => {
        const position = option.getAttribute('data-option-position');
        const value = option.getAttribute('data-value');
        const exists = optionHasVariant(position, value, false);
        const available = optionHasVariant(position, value, true);

        option.classList.toggle('disabled', !exists);
        option.classList.toggle('sold-out', exists && !available);
      });
    }

    // Helper function to update variant and UI
    function updateVariantSelection() {
      const variant = findVariantByOptions(selectedOptions);
      
      if (variant) {
        // Update hidden inputs
        if (variantInput) variantInput.value = variant.id;
        if (mobileVariantInput) mobileVariantInput.value = variant.id;
        
        // Update price display
        const formattedPrice = formatPrice(variant.price);
        priceElements.forEach((el) => {
          el.textContent = formattedPrice;
        });
        mobilePriceElements.forEach((el) => {
          el.textContent = formattedPrice;
        });
        
        // Handle compare price
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const formattedComparePrice = formatPrice(variant.compare_at_price);
          if (comparePriceElement) {
            comparePriceElement.textContent = formattedComparePrice;
            comparePriceElement.style.display = 'inline';
          }
          if (mobileComparePriceElement) {
            mobileComparePriceElement.textContent = formattedComparePrice;
            mobileComparePriceElement.style.display = 'inline';
          }
          priceElements.forEach((el) => {
            el.className = el.className.replace('pdp-price--regular', 'pdp-price--sale');
          });
        } else {
          if (comparePriceElement) comparePriceElement.style.display = 'none';
          if (mobileComparePriceElement) mobileComparePriceElement.style.display = 'none';
          priceElements.forEach((el) => {
            el.className = el.className.replace('pdp-price--sale', 'pdp-price--regular');
          });
        }
        
        // Update add to cart buttons and notify buttons (both desktop and mobile)
        // When STOQ app embed is disabled, show default sold-out state (add to cart disabled) instead of notify button
        const stoqAvailable = !!(window._RestockRocket && window._RestockRocket.openModal);
        console.log('Updating buttons for variant:', variant.id, 'Available:', variant.available, 'STOQ:', stoqAvailable);
        
        const notifyBtns = document.querySelectorAll('[data-notify-button]');
        
        addToCartBtns.forEach(btn => {
          if (variant.available) {
            btn.disabled = false;
            btn.textContent = 'Add to bag';
            btn.style.display = '';
          } else {
            btn.disabled = true;
            btn.textContent = 'Sold out';
            btn.style.display = 'none';
          }
        });
        
        notifyBtns.forEach((btn) => {
          if (variant.available) {
            setNotifyVisible(btn, false);
          } else {
            setNotifyVisible(btn, true);
            if (stoqAvailable && window._RestockRocket.renderButtonForVariant) {
              window._RestockRocket.renderButtonForVariant(variant.id.toString());
            }
          }
        });
        
        // Update option availability based on new selection
        updateOptionAvailability();
        
        console.log('Variant selected:', variant.title, variant.id);
      }
    }
    
    // Count total options (both visible dropdowns and auto-selected single options)
    const totalOptions = document.querySelectorAll('.pdp-variant-selector, .pdp-single-option').length;
    const visibleOptions = document.querySelectorAll('.pdp-variant-selector').length;
    
    // If all options are auto-selected (e.g., product with only one color), update variant selection
    if (Object.keys(selectedOptions).length === totalOptions && totalOptions > 0) {
      updateVariantSelection();
      initialButtonStateSet = true;
    } else if (totalOptions === 0) {
      // Product has no options (single variant), ensure button state is correct
      const singleVariant = productVariants[0];
      if (singleVariant) {
        const stoqAvail = !!(window._RestockRocket && window._RestockRocket.openModal);
        addToCartBtns.forEach(btn => {
          if (singleVariant.available) {
            btn.disabled = false;
            btn.textContent = 'Add to bag';
            btn.style.display = '';
          } else {
            btn.disabled = true;
            btn.textContent = 'Sold out';
            btn.style.display = 'none';
          }
        });
        const singleNotifyBtns = document.querySelectorAll('[data-notify-button]');
        singleNotifyBtns.forEach(btn => {
          setNotifyVisible(btn, !singleVariant.available);
        });
        initialButtonStateSet = true;
      }
    } else if (visibleOptions > 0) {
      // Product has visible options user needs to select, disable button until selection
      addToCartBtns.forEach(btn => {
        btn.disabled = true;
        btn.textContent = 'Select options';
      });
    }

    // Handle each dropdown
    dropdownTriggers.forEach((trigger) => {
      const dropdownType = trigger.getAttribute('data-dropdown');
      const dropdownMenu = document.querySelector(`[data-dropdown-menu="${dropdownType}"]`);
      const dropdownValue = trigger.querySelector('.dropdown-value');

      // Skip if dropdownMenu is not found (like for mobile-variant-header)
      if (!dropdownMenu) {
        return;
      }

      const dropdownOptions = dropdownMenu.querySelectorAll('.dropdown-option, .size-option');

      if (dropdownMenu) {
        // Toggle dropdown
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          // Skip if disabled
          if (trigger.classList.contains('disabled')) {
            return;
          }

          const isActive = trigger.classList.contains('active');

          // Close all other dropdowns first
          document.querySelectorAll('.dropdown-trigger.active').forEach((t) => {
            t.classList.remove('active');
          });
          document.querySelectorAll('.dropdown-menu.active').forEach((menu) => {
            menu.classList.remove('active');
          });

          // Toggle current dropdown
          if (!isActive) {
            trigger.classList.add('active');
            dropdownMenu.classList.add('active');
          }
        });

        // Handle option selection
        dropdownOptions.forEach((option) => {
          option.addEventListener('click', function () {
            // Skip if disabled
            if (this.classList.contains('disabled')) {
              return;
            }

            const value = this.getAttribute('data-value');
            const optionPosition = this.getAttribute('data-option-position');

            // Update selected state within this dropdown
            dropdownOptions.forEach((opt) => opt.classList.remove('selected'));
            this.classList.add('selected');

            // Handle different dropdown types
            if (dropdownType === 'quantity' || dropdownType === 'mobile-quantity') {
              // Update quantity for both desktop and mobile
              dropdownValue.textContent = value;
              if (quantityInput) quantityInput.value = value;
              if (mobileQuantityInput) mobileQuantityInput.value = value;
            } else if (dropdownType.startsWith('option-') || dropdownType.startsWith('mobile-option-')) {
              // Handle variant option selection (Color, Size, etc.)
              if (optionPosition) {
                // Store the selected value for this option position
                selectedOptions[optionPosition] = value;
                
                // Update the dropdown display
                dropdownValue.textContent = value;
                dropdownValue.classList.remove('placeholder');
                
                // Update all dropdowns with the same option position (desktop + mobile)
                document.querySelectorAll(`[data-option-position="${optionPosition}"] .dropdown-value`).forEach(el => {
                  el.textContent = value;
                  el.classList.remove('placeholder');
                });
                
                // Update all size-options with the same position to show selected state
                document.querySelectorAll(`[data-option-position="${optionPosition}"].size-option`).forEach(opt => {
                  if (opt.getAttribute('data-value') === value) {
                    opt.classList.add('selected');
                  } else {
                    opt.classList.remove('selected');
                  }
                });
                
                // Find and update the variant
                updateVariantSelection();
              }
            }

            // Close dropdown instantly (no transition) for better UX
            dropdownMenu.style.transition = 'none';
            trigger.classList.remove('active');
            dropdownMenu.classList.remove('active');
            
            // Restore transition after a brief moment for future interactions
            setTimeout(() => {
              dropdownMenu.style.transition = '';
            }, 50);
          });
        });
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function (e) {
      const clickedDropdown = e.target.closest('.custom-dropdown');
      if (!clickedDropdown) {
        document.querySelectorAll('.dropdown-trigger.active').forEach((trigger) => {
          trigger.classList.remove('active');
        });
        document.querySelectorAll('.dropdown-menu.active').forEach((menu) => {
          menu.classList.remove('active');
        });
      }
    });

    // Close dropdown on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.dropdown-trigger.active').forEach((trigger) => {
          trigger.classList.remove('active');
        });
        document.querySelectorAll('.dropdown-menu.active').forEach((menu) => {
          menu.classList.remove('active');
        });
      }
    });

    // Handle mobile dropdown header clicks (close only)
    function setupMobileDropdownHeaders() {
      const mobileHeaders = document.querySelectorAll('.mobile-dropdown-header');

      mobileHeaders.forEach((headerTrigger) => {
        headerTrigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          // Close all dropdowns
          document.querySelectorAll('.dropdown-trigger.active').forEach((trigger) => {
            trigger.classList.remove('active');
          });
          document.querySelectorAll('.dropdown-menu.active').forEach((menu) => {
            menu.classList.remove('active');
          });
        });
      });
    }

    // Handle dropdown text label clicks (close dropdown)
    function setupDropdownTextLabels() {
      const textLabels = document.querySelectorAll('.dropdown-text-label');

      textLabels.forEach((textLabel) => {
        textLabel.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          // Find the parent dropdown menu and its trigger
          const dropdownMenu = textLabel.closest('.dropdown-menu');
          if (dropdownMenu) {
            const dropdownType = dropdownMenu.getAttribute('data-dropdown-menu');
            const trigger = document.querySelector(`[data-dropdown="${dropdownType}"]`);

            if (trigger) {
              // Close this specific dropdown
              trigger.classList.remove('active');
              dropdownMenu.classList.remove('active');
            }
          }
        });
      });
    }

    // Run immediately and also after a short delay to ensure DOM is ready
    setupMobileDropdownHeaders();
    setupDropdownTextLabels();
    setTimeout(setupMobileDropdownHeaders, 100);
    setTimeout(setupDropdownTextLabels, 100);

    // Handle add to cart form submission
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
    addToCartForms.forEach((form) => {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;

        // Debug logging
        console.log('Add to cart form data:', {
          variantId: variantId,
          quantity: quantity,
          formDataEntries: Array.from(formData.entries()),
        });

        // Validate variant ID - but be smarter about products with/without variants
        if (!variantId || variantId === 'id' || variantId === '' || variantId === 'null' || variantId === null) {
          console.error('Invalid variant ID detected:', variantId);

          // Check if this product actually has multiple variants
          const hasVisibleVariants =
            form.querySelector('.pdp-variant-selector') || form.querySelector('.pdp-mobile-size-dropdown');
          const hasAutoSelectedVariants = document.querySelector('.pdp-single-option');
          const singleVariantInput = form.querySelector('input[name="id"][data-single-variant="true"]');

          // Log debug information
          console.log('Variant validation debug:', {
            variantId: variantId,
            hasVisibleVariants: !!hasVisibleVariants,
            hasAutoSelectedVariants: !!hasAutoSelectedVariants,
            singleVariantInput: !!singleVariantInput,
            formElements: Array.from(form.elements).map((el) => ({ name: el.name, value: el.value, type: el.type })),
          });

          if (hasVisibleVariants) {
            // Product has variants, user must select one
            alert('Please select a size before adding to cart.');
            return;
          } else if (singleVariantInput) {
            // Product has only default variant - there might be a product configuration issue
            console.error(
              'Single variant product has invalid variant ID. Product may be unavailable or misconfigured.'
            );
            console.log('Single variant input details:', {
              value: singleVariantInput.value,
              attributes: Array.from(singleVariantInput.attributes).map((attr) => ({
                name: attr.name,
                value: attr.value,
              })),
            });
            alert('This product appears to be unavailable. Please contact support if this persists.');
            return;
          } else if (!singleVariantInput && !hasAutoSelectedVariants) {
            // Unknown case - let's try to find any input with name="id"
            const anyIdInput = form.querySelector('input[name="id"]');
            if (anyIdInput) {
              console.log('Found alternative ID input:', {
                value: anyIdInput.value,
                attributes: Array.from(anyIdInput.attributes).map((attr) => ({ name: attr.name, value: attr.value })),
              });
              // If we found an ID input but it's empty, this is a configuration issue
              alert('Product configuration error. Please contact support.');
            } else {
              console.error('No variant ID input found at all.');
              alert('There was an error with this product. Please try again later.');
            }
            return;
          }
          // If we have auto-selected variants, continue with the submission
        }

        // Get any properties
        const properties = {};
        for (const [key, value] of formData.entries()) {
          if (key.startsWith('properties[')) {
            const propKey = key.match(/properties\[(.+)\]/)[1];
            properties[propKey] = value;
          }
        }

        // Disable add to cart button temporarily
        const submitBtn = form.querySelector('.pdp-add-to-cart');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding...';
        }

        // Use the global addToCart function
        window
          .addToCart(variantId, quantity, properties)
          .then(() => {
            // Re-enable button
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = 'Add to bag';
            }
          })
          .catch((error) => {
            // Re-enable button on error
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = 'Add to bag';
            }
            console.error('Add to cart failed:', error);
          });
      });
    });

    // Handle STOQ Notify Me button clicks
    console.log('Initializing STOQ notify buttons...');
    const notifyBtns = document.querySelectorAll('[data-notify-button]');
    console.log('Found', notifyBtns.length, 'notify buttons on page load');
    
    // Check if ALL variants are out of stock on initial load
    const allVariantsOutOfStock = productVariants.every(variant => !variant.available);

    const hasVariantChooser = document.querySelector('.pdp-variant-selector');
    const onlyVariantSoldOut = !hasVariantChooser && productVariants[0] && !productVariants[0].available;
    const fullySoldOut = allVariantsOutOfStock && productVariants.length > 0;

    function revealSoldOutNotify() {
      if (!fullySoldOut && !onlyVariantSoldOut) return;
      addToCartBtns.forEach(btn => {
        btn.disabled = true;
        btn.textContent = 'Sold out';
        btn.style.display = 'none';
      });
      notifyBtns.forEach(btn => { setNotifyVisible(btn, true); });
      const variantId = (productVariants[0] && productVariants[0].id) || '';
      if (variantId && stoqIsReady() && window._RestockRocket.renderButtonForVariant) {
        window._RestockRocket.renderButtonForVariant(String(variantId));
      }
    }

    // No size to pick, or every size is sold out: show notify without waiting for a selection.
    // STOQ often loads after this script, so keep checking until it is available.
    revealSoldOutNotify();
    window.addEventListener('stoq:loaded', function() {
      if (fullySoldOut || onlyVariantSoldOut) {
        revealSoldOutNotify();
      } else {
        updateVariantSelection();
      }
    });
    let stoqChecks = 0;
    const stoqWatch = setInterval(function() {
      stoqChecks += 1;
      if (stoqIsReady() || stoqChecks > 20) {
        clearInterval(stoqWatch);
        if (fullySoldOut || onlyVariantSoldOut) revealSoldOutNotify();
      }
    }, 250);
    
    notifyBtns.forEach((btn, index) => {
      console.log('Button', index, ':', {
        display: btn.style.display,
        computedDisplay: window.getComputedStyle(btn).display,
        classes: btn.className,
        visible: btn.offsetWidth > 0 && btn.offsetHeight > 0
      });
      
      btn.addEventListener('click', function() {
        console.log('Notify button clicked!');
        
        // Find the closest form to get variant ID
        const leftColumn = this.closest('.pdp-left-column');
        const mobileFooter = this.closest('.pdp-mobile-sticky-footer');
        const parentEl = leftColumn || mobileFooter;
        const form = parentEl ? parentEl.querySelector('form[action="/cart/add"]') : null;
        
        if (!form) {
          console.error('Could not find product form for notify button');
          return;
        }
        
        const variantInput = form.querySelector('input[name="id"]');
        let variantId = variantInput ? variantInput.value : null;
        
        // If no variant is selected (all out of stock), use first variant
        if (!variantId && productVariants.length > 0) {
          variantId = productVariants[0].id.toString();
          console.log('No variant selected, using first variant:', variantId);
        }
        
        console.log('Variant ID:', variantId);
        
        // Get product data from JSON script element
        const productDataEl = document.getElementById('product-data-stoq');
        const productData = productDataEl ? JSON.parse(productDataEl.textContent) : null;
        
        if (!productData) {
          console.error('Could not load product data for STOQ');
          return;
        }
        
        console.log('Product Data:', productData);
        
        // Amend variant names for STOQ modal dropdown. Variant has: title, option1, option2, option3.
        // Change the return below to customize, e.g. option2 + ' / ' + option1, or option1 only.
        function formatStoqVariantName(variant) {
          return variant.option2;
        }
        const stoqVariants = (productData.variants || []).map(function(v) {
          var copy = Object.assign({}, v);
          copy.title = formatStoqVariantName(v);
          return copy;
        });
        
        // Format data for STOQ API (openModal expects productData, variantId, customerData)
        const stoqProductData = {
          id: productData.productId,
          variants: stoqVariants
        };
        const customerData = productData.customerData || {};
        
        // Check if STOQ API is available
        if (window._RestockRocket && window._RestockRocket.openModal) {
          console.log('STOQ API available, opening modal...');
          // Open STOQ modal with product, variant, and customer data (customerData ensures email field is shown)
          window._RestockRocket.openModal(stoqProductData, variantId, customerData);
        } else {
          console.warn('STOQ RestockRocket API not available. Window._RestockRocket:', window._RestockRocket);
          alert('Waitlist functionality is currently unavailable. Please try again later.');
        }
      });
    });

    // Simple scroll tracking for image gallery
    const galleryScroll = document.querySelector('.pdp-images__scroll');
    if (galleryScroll) {
      // Optional: Add simple scroll position tracking if needed
      let scrollTimeout;
      galleryScroll.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          // Scroll ended - can add analytics or other features here
        }, 150);
      });
    }

    // Simple product carousel - clone products above and below, center instantly
    function initProductCarousel() {
      const productsList = document.querySelector('[data-product-carousel]');
      const rightColumn = document.querySelector('.pdp-right-column');
      
      if (!productsList || !rightColumn) return;
      
      // Get all original products
      const allProducts = Array.from(productsList.querySelectorAll('.pdp-product-item'));
      if (allProducts.length === 0) return;
      
      // Clone products 3 times above and below
      const clonesBefore = [];
      const clonesAfter = [];
      
      for (let i = 0; i < 3; i++) {
        allProducts.forEach(product => {
          const cloneBefore = product.cloneNode(true);
          const cloneAfter = product.cloneNode(true);
          clonesBefore.push(cloneBefore);
          clonesAfter.push(cloneAfter);
        });
      }
      
      // Insert clones
      clonesBefore.reverse().forEach(clone => {
        productsList.insertBefore(clone, productsList.firstChild);
      });
      clonesAfter.forEach(clone => {
        productsList.appendChild(clone);
      });
      
      // Disable transition for initial centering
      productsList.style.transition = 'none';
      
      // Center immediately without animation
      centerCurrentProduct();
      
      // Re-enable transition after a brief moment
      setTimeout(() => {
        productsList.style.transition = '';
      }, 50);
    }
    
    function centerCurrentProduct() {
      const productsList = document.querySelector('[data-product-carousel]');
      const rightColumn = document.querySelector('.pdp-right-column');
      
      if (!productsList || !rightColumn) return;
      
      // Find current product
      const currentProduct = productsList.querySelector('.pdp-product-item.current');
      if (!currentProduct) return;
      
      // Get all products
      const allProducts = Array.from(productsList.querySelectorAll('.pdp-product-item'));
      const currentIndex = allProducts.indexOf(currentProduct);
      
      // Calculate center position
      const columnHeight = rightColumn.clientHeight;
      const columnCenter = columnHeight / 2;
      
      let offsetTop = 0;
      for (let i = 0; i < currentIndex; i++) {
        offsetTop += allProducts[i].offsetHeight + 4; // height + gap
      }
      offsetTop += currentProduct.offsetHeight / 2;
      
      const transformY = columnCenter - offsetTop;
      
      // Apply transform
      productsList.style.transform = `translateY(${transformY}px)`;
    }
    
    // Handle product clicks for smooth transitions
    function setupProductNavigation() {
      const productsList = document.querySelector('[data-product-carousel]');
      if (!productsList) return;
      
      // Delegate click events to product items
      productsList.addEventListener('click', (e) => {
        const clickedProduct = e.target.closest('.pdp-product-item');
        if (!clickedProduct) return;
        
        // Don't prevent navigation if it's the current product
        if (clickedProduct.classList.contains('current')) return;
        
        e.preventDefault();
        
        // Get the URL to navigate to
        const targetUrl = clickedProduct.getAttribute('href');
        if (!targetUrl) return;
        
        // Update current state
        const allProducts = productsList.querySelectorAll('.pdp-product-item');
        allProducts.forEach(product => {
          if (product.getAttribute('href') === targetUrl) {
            product.classList.add('current');
          } else {
            product.classList.remove('current');
          }
        });
        
        // Animate to new position
        centerCurrentProduct();
        
        // Navigate after animation completes
        setTimeout(() => {
          window.location.href = targetUrl;
        }, 500);
      });
    }
    
    // Initialize
    initProductCarousel();
    setupProductNavigation();

    // Mobile Navigation Dots Functionality
    const mobileGallery = document.querySelector('.pdp-mobile-gallery');
    const navDots = document.querySelectorAll('.pdp-mobile-nav-dot');
    const imageSlides = document.querySelectorAll('.pdp-mobile-image-slide');

    if (mobileGallery && navDots.length > 0 && imageSlides.length > 0) {
      // Update active dot based on scroll position
      function updateActiveDot() {
        const scrollTop = mobileGallery.scrollTop;
        const containerHeight = mobileGallery.clientHeight;

        let activeIndex = 0;
        imageSlides.forEach((slide, index) => {
          const slideTop = slide.offsetTop;
          const slideHeight = slide.offsetHeight;
          const slideCenter = slideTop + slideHeight / 2;

          if (scrollTop + containerHeight / 2 >= slideCenter) {
            activeIndex = index;
          }
        });

        // Update dot states
        navDots.forEach((dot, index) => {
          dot.classList.toggle('active', index === activeIndex);
        });
      }

      // Click on dot to scroll to image
      navDots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          if (imageSlides[index]) {
            imageSlides[index].scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }
        });
      });

      // Update dots on scroll
      let scrollTimeout;
      mobileGallery.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateActiveDot, 100);
      });

      // Initial dot state
      updateActiveDot();
    }

    // Mobile Info Button Functionality - Scroll to Details
    const mobileInfoBtn = document.querySelector('.pdp-mobile-info-btn');
    if (mobileInfoBtn) {
      mobileInfoBtn.addEventListener('click', () => {
        const detailsSlide = document.getElementById('mobile-product-details-overlay');
        if (detailsSlide) {
          detailsSlide.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      });
    }

    // Accordion interactions (Product Details slide)
    const accordionHeaders = document.querySelectorAll('.pdp-accordion__header');
    accordionHeaders.forEach((header) => {
      const item = header.closest('.pdp-accordion__item');
      const content = item ? item.querySelector('.pdp-accordion__content') : null;
      if (!item || !content) return;

      // Set initial state without animation
      const initiallyOpen = item.classList.contains('is-open');
      header.setAttribute('aria-expanded', initiallyOpen ? 'true' : 'false');
      content.style.maxHeight = initiallyOpen ? 'none' : '0px';

      header.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        if (isOpen) {
          // CLOSE: if max-height is none, set it to current height first to enable transition
          const currentHeight = content.scrollHeight;
          content.style.maxHeight = currentHeight + 'px';
          // force reflow to ensure the browser picks up the start height
          void content.offsetHeight;
          content.style.maxHeight = '0px';
          item.classList.remove('is-open');
          header.setAttribute('aria-expanded', 'false');
        } else {
          // CLOSE all other open accordion items first
          const allAccordionItems = document.querySelectorAll('.pdp-accordion__item');
          allAccordionItems.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains('is-open')) {
              const otherContent = otherItem.querySelector('.pdp-accordion__content');
              const otherHeader = otherItem.querySelector('.pdp-accordion__header');
              if (otherContent && otherHeader) {
                const otherCurrentHeight = otherContent.scrollHeight;
                otherContent.style.maxHeight = otherCurrentHeight + 'px';
                void otherContent.offsetHeight;
                otherContent.style.maxHeight = '0px';
                otherItem.classList.remove('is-open');
                otherHeader.setAttribute('aria-expanded', 'false');
              }
            }
          });

          // OPEN: set explicit height so it animates from 0 -> height
          item.classList.add('is-open');
          header.setAttribute('aria-expanded', 'true');
          const targetHeight = content.scrollHeight;
          content.style.maxHeight = targetHeight + 'px';
          const onEnd = (e) => {
            if (e.propertyName !== 'max-height') return;
            // allow dynamic height after animation completes
            content.style.maxHeight = 'none';
            content.removeEventListener('transitionend', onEnd);
          };
          content.addEventListener('transitionend', onEnd);
        }
      });

      // Keep open panels sized correctly on resize/font load
      const recalc = () => {
        if (item.classList.contains('is-open')) {
          // If open and not animating, keep it flexible
          if (getComputedStyle(content).maxHeight !== '0px') {
            content.style.maxHeight = 'none';
          }
        }
      };
      window.addEventListener('resize', recalc);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(recalc).catch(() => {});
      }
    });

    // Jump link functionality
    const detailsJumpBtn = document.querySelector('.pdp-details-jump__btn');
    const galleryJumpBtn = document.querySelector('.pdp-gallery-jump__btn');
    const detailsJump = document.querySelector('.pdp-details-jump');
    const galleryJump = document.querySelector('.pdp-gallery-jump');
    const imageScroll = document.querySelector('.pdp-images__scroll');
    const detailsSlide = document.getElementById('product-details-slide');

    // Mobile: Dynamically calculate bottom panel height
    function updateMobileBottomPanelHeight() {
      if (window.innerWidth <= 1023) {
        const bottomPanel = document.querySelector('.pdp-info__content');
        if (bottomPanel) {
          const panelHeight = bottomPanel.offsetHeight;
          document.documentElement.style.setProperty('--mobile-bottom-panel-height', panelHeight + 'px');
        }
      }
    }

    // Update on load and resize
    updateMobileBottomPanelHeight();
    window.addEventListener('resize', updateMobileBottomPanelHeight);
    window.addEventListener('orientationchange', () => {
      setTimeout(updateMobileBottomPanelHeight, 100);
    });

    // Handle click events for both buttons
    [detailsJumpBtn, galleryJumpBtn].forEach((btn) => {
      if (btn) {
        btn.addEventListener('click', function () {
          const targetId = this.getAttribute('data-scroll-to');
          const targetElement = document.getElementById(targetId);
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        });
      }
    });

    // Scroll detection to show/hide appropriate buttons
    if (imageScroll && detailsSlide) {
      let scrollTimeout;

      const checkScrollPosition = () => {
        const scrollContainer = imageScroll;
        const containerRect = scrollContainer.getBoundingClientRect();
        const slideRect = detailsSlide.getBoundingClientRect();

        // Check if details slide is approaching view (top of slide is at or above 90% down the viewport)
        // This triggers the jump links well before the scroll completes, giving a smoother transition
        const slideInView = slideRect.top <= containerRect.top + containerRect.height * 0.9;

        if (slideInView) {
          // At details slide - show gallery button, hide details button
          if (detailsJump) detailsJump.classList.add('hidden');
          if (galleryJump) galleryJump.classList.add('visible');
        } else {
          // In gallery - show details button, hide gallery button
          if (detailsJump) detailsJump.classList.remove('hidden');
          if (galleryJump) galleryJump.classList.remove('visible');
        }
      };

      imageScroll.addEventListener('scroll', function () {
        // Remove throttling to make changes more immediate
        checkScrollPosition();
      });

      // Initial check
      setTimeout(checkScrollPosition, 100);
    }

    // Image Zoom Modal Functionality (Desktop Only)
    if (window.innerWidth > 767) {
      const zoomModal = document.getElementById('pdp-zoom-modal');
      const zoomOverlay = document.getElementById('pdp-zoom-overlay');
      const zoomClose = document.getElementById('pdp-zoom-close');
      const zoomImage = document.getElementById('pdp-zoom-image');
      const zoomLoader = document.getElementById('pdp-zoom-loader');
      const zoomPrev = document.getElementById('pdp-zoom-prev');
      const zoomNext = document.getElementById('pdp-zoom-next');

      let currentZoomIndex = 0;
      let productImages = [];
      let prefetchedImages = new Set();

      // Collect desktop product images with zoom data
      const collectProductImages = () => {
        const desktopImages = document.querySelectorAll('.pdp-image[data-zoom-src]');

        productImages = [];

        desktopImages.forEach((img, index) => {
          productImages.push({
            src: img.getAttribute('data-zoom-src'),
            alt: img.alt || `Product image ${index + 1}`,
            index: parseInt(img.getAttribute('data-zoom-index')) || index,
          });
        });

        // Set single image attribute
        if (productImages.length <= 1) {
          zoomModal.setAttribute('data-single-image', 'true');
        } else {
          zoomModal.removeAttribute('data-single-image');
        }
      };

      // Prefetch zoom images in the background
      const prefetchZoomImage = (index) => {
        if (index < 0 || index >= productImages.length) return;
        const imageData = productImages[index];
        if (prefetchedImages.has(imageData.src)) return;
        
        const img = new Image();
        img.src = imageData.src;
        prefetchedImages.add(imageData.src);
      };

      // Open zoom modal
      const openZoom = (index) => {
        if (!productImages.length) return;

        currentZoomIndex = index;
        const imageData = productImages[currentZoomIndex];

        // Show loader, hide image
        if (zoomLoader) zoomLoader.classList.remove('hidden');
        zoomImage.classList.remove('loaded');
        
        // Create new image to preload before showing
        const tempImg = new Image();
        tempImg.onload = () => {
        zoomImage.src = imageData.src;
        zoomImage.alt = imageData.alt;
          if (zoomLoader) zoomLoader.classList.add('hidden');
          zoomImage.classList.add('loaded');
          
          // Prefetch adjacent images for smoother navigation
          prefetchZoomImage(currentZoomIndex - 1);
          prefetchZoomImage(currentZoomIndex + 1);
        };
        tempImg.onerror = () => {
          // Even on error, show the image and hide loader
          zoomImage.src = imageData.src;
          zoomImage.alt = imageData.alt;
          if (zoomLoader) zoomLoader.classList.add('hidden');
          zoomImage.classList.add('loaded');
        };
        tempImg.src = imageData.src;

        zoomModal.classList.add('active');
        document.body.style.overflow = 'hidden';
      };

      // Close zoom modal
      const closeZoom = () => {
        zoomModal.classList.remove('active');
        document.body.style.overflow = '';
        
        // Reset image to prevent flash of previous image on next open
        setTimeout(() => {
          zoomImage.src = '';
          zoomImage.classList.remove('loaded');
          if (zoomLoader) zoomLoader.classList.remove('hidden');
        }, 300); // Wait for modal close transition to complete
      };

      // Navigate to previous image
      const prevImage = () => {
        if (productImages.length <= 1) return;
        currentZoomIndex = currentZoomIndex > 0 ? currentZoomIndex - 1 : productImages.length - 1;
        openZoom(currentZoomIndex);
      };

      // Navigate to next image
      const nextImage = () => {
        if (productImages.length <= 1) return;
        currentZoomIndex = currentZoomIndex < productImages.length - 1 ? currentZoomIndex + 1 : 0;
        openZoom(currentZoomIndex);
      };

      // Initialize zoom functionality
      const initZoom = () => {
        collectProductImages();

        // Add click handlers to desktop images only
        document.querySelectorAll('.pdp-image[data-zoom-src]').forEach((img) => {
          img.addEventListener('click', (e) => {
            e.preventDefault();
            const index = parseInt(img.getAttribute('data-zoom-index')) || 0;
            openZoom(index);
          });
        });

        // Prefetch zoom images in the background after page is idle
        // Start with images 1-3 (first is already prefetched in HTML)
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => {
            for (let i = 1; i < Math.min(4, productImages.length); i++) {
              prefetchZoomImage(i);
            }
          }, { timeout: 2000 });
        } else {
          // Fallback for browsers without requestIdleCallback
          setTimeout(() => {
            for (let i = 1; i < Math.min(4, productImages.length); i++) {
              prefetchZoomImage(i);
            }
          }, 2000);
        }

         // Modal controls
         if (zoomClose) {
           zoomClose.addEventListener('click', closeZoom);
         }

         if (zoomOverlay) {
           zoomOverlay.addEventListener('click', closeZoom);
         }

         // Close when clicking the zoom image
         if (zoomImage) {
           zoomImage.addEventListener('click', closeZoom);
         }

        if (zoomPrev) {
          zoomPrev.addEventListener('click', prevImage);
        }

        if (zoomNext) {
          zoomNext.addEventListener('click', nextImage);
        }

        // Keyboard navigation
        document.addEventListener('keydown', (e) => {
          if (!zoomModal.classList.contains('active')) return;

          switch (e.key) {
            case 'Escape':
              e.preventDefault();
              closeZoom();
              break;
            case 'ArrowLeft':
              e.preventDefault();
              prevImage();
              break;
            case 'ArrowRight':
              e.preventDefault();
              nextImage();
              break;
          }
        });
      };

      // Initialize zoom functionality
      initZoom();
    }

    // Size guide modal: open overlay with PNG when button is clicked
    const sizeGuideModal = document.getElementById('pdp-size-guide-modal');
    if (sizeGuideModal) {
      const sizeGuideOverlay = document.getElementById('pdp-size-guide-overlay');
      const sizeGuideClose = document.getElementById('pdp-size-guide-close');

      const openSizeGuide = () => {
        sizeGuideModal.classList.add('active');
        sizeGuideModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };

      const closeSizeGuide = () => {
        sizeGuideModal.classList.remove('active');
        sizeGuideModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      document.querySelectorAll('[data-size-guide-open]').forEach(btn => {
        btn.addEventListener('click', openSizeGuide);
      });
      sizeGuideModal.addEventListener('click', closeSizeGuide);
      if (sizeGuideOverlay) sizeGuideOverlay.addEventListener('click', closeSizeGuide);
      if (sizeGuideClose) sizeGuideClose.addEventListener('click', closeSizeGuide);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && sizeGuideModal.classList.contains('active')) {
          closeSizeGuide();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-hero-live-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const heroSection = document.querySelector('.promo-hero-live-text');
    if (!heroSection) return;

    // Body class scoped in header.css / css-variables for floating-link difference mode
    document.body.classList.add('has-promo-hero-live-text');
    document.body.classList.add('hero-visible');

    // Detect when user scrolls past the hero
    function checkHeroVisibility() {
      const heroBottom = heroSection.getBoundingClientRect().bottom;
      
      if (heroBottom <= 0) {
        // Hero has been scrolled past
        document.body.classList.remove('hero-visible');
      } else {
        // Hero is still visible
        document.body.classList.add('hero-visible');
      }
    }

    // Check on scroll
    window.addEventListener('scroll', checkHeroVisibility);
    
    // Check on resize
    window.addEventListener('resize', checkHeroVisibility);
    
    // Initial check
    checkHeroVisibility();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-image-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const heroSection = document.querySelector('.single-image-hero');
    if (!heroSection) return;

    // Mark body as having a single image hero
    document.body.classList.add('has-single-image-hero');
    document.body.classList.add('hero-visible');

    // Detect when user scrolls past the hero
    function checkHeroVisibility() {
      const heroBottom = heroSection.getBoundingClientRect().bottom;
      
      if (heroBottom <= 0) {
        // Hero has been scrolled past
        document.body.classList.remove('hero-visible');
      } else {
        // Hero is still visible
        document.body.classList.add('hero-visible');
      }
    }

    // Check on scroll
    window.addEventListener('scroll', checkHeroVisibility);
    
    // Check on resize
    window.addEventListener('resize', checkHeroVisibility);
    
    // Initial check
    checkHeroVisibility();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-block"] && !Shopify.designMode) return;
  try {
    
  // Add class to body when text block is in viewport
  document.addEventListener('DOMContentLoaded', function() {
    const textBlocks = document.querySelectorAll('.text-block');
    
    if (textBlocks.length === 0) return;
    
    const observer = new IntersectionObserver((entries) => {
      let textBlockVisible = false;
      
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          textBlockVisible = true;
        }
      });
      
      // Check if any text block is currently visible
      textBlocks.forEach(block => {
        const rect = block.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // Check if text block overlaps with top portion of viewport (where header is)
        if (rect.top < windowHeight * 0.3 && rect.bottom > 0) {
          textBlockVisible = true;
        }
      });
      
      // Header visibility now handled by viewport detection system
    }, {
      threshold: [0, 0.1, 0.5],
      rootMargin: '-10% 0px -70% 0px'
    });
    
    textBlocks.forEach(block => observer.observe(block));
    
    // Also check on scroll for more precise detection
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        let textBlockVisible = false;
        
        textBlocks.forEach(block => {
          const rect = block.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          
          // Check if text block overlaps with top portion of viewport
          if (rect.top < windowHeight * 0.3 && rect.bottom > 0) {
            textBlockVisible = true;
          }
        });
        
        // Removed automatic header color changes - using mix-blend-mode instead
      }, 10);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
